module.exports = __webpack_public_path__ + "img/384.6b6ffa9b.jpg";